module.exports = __webpack_public_path__ + "img/1618403046.c283eccc.png";